/**
 * Production-aware logger.
 *
 * Wraps console.* so:
 *   - `logger.debug` / `logger.info` are SILENCED in production builds
 *     (so we don't ship verbose internal logs to end users)
 *   - `logger.warn` / `logger.error` always pass through (we still want
 *     visibility on real problems even in production)
 *   - the existing client-error-reporter intercepts console.error so
 *     `logger.error` automatically reaches the server-side error log too.
 *
 * Use:
 *   import { logger } from '../utils/logger';
 *   logger.debug('fetched jobs', n);
 *   logger.error('save failed', err);
 *
 * Migration tip: every former `console.log(…)` becomes `logger.debug(…)`.
 */
const isProd = (typeof process !== 'undefined') && process.env.NODE_ENV === 'production';

const noop = () => {};

export const logger = {
  // Verbose, dev-only
  debug: isProd ? noop : (...args) => console.log(...args),
  log:   isProd ? noop : (...args) => console.log(...args),
  info:  isProd ? noop : (...args) => console.info(...args),
  // Always-on
  warn:  (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
